import React from "react";
import useBreakpoint from "../useBreakpoint";

const withBreakpoint = () => (Component) => (props) => {
  const { isMobile } = useBreakpoint();
  return <Component isMobile={isMobile} {...props} />;
};

export default withBreakpoint;
